import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { UserService } from "../../services/user/user.service";
import { TrademarkService } from "../../services/trademark/trademark.service";
import { MerchantService } from "../../services/merchant/merchant.service";
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NeedAuthorize } from "../../classes/needAuthorize";
import { Global } from "../../classes/global";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from "ngx-toastr";

@Component({
  selector: 'app-trademark-list',
  templateUrl: './trademark-list.component.html',
  styleUrls: ['./trademark-list.component.scss']
})
export class TrademarkListComponent extends NeedAuthorize {
  @ViewChild('trademarkModal') trademarkModal: ElementRef;

  query = {
    queryString: '',
    pageSize: 10,
    pageNumber: 1
  };

  queryResult: any = {
    items: [],
    total: 0
  };

  trademarkDetail: any = {
    id: '',
    text: '',
    note: '',
    merchantGroupId: '',
    merchantGroup: {
      id: '',
      name: ''
    }
  };

  merchantGroups = [];

  userData: any;

  constructor(protected router: Router,
    protected userService: UserService,
    protected titleService: Title,
    private global: Global,
    private modalService: NgbModal,
    private trademarkService: TrademarkService,
    private merchantService: MerchantService,
    private toastr: ToastrService) {
    super(router, userService, titleService);
    this.queryTrademarks();
    this.getMerchantGroups();
  }

  ngOnInit(): void {
  }

  queryTrademarks(page = undefined) {
    if (page != undefined) {
      this.query.pageNumber = page;
    }
    this.global.pageLoading = true;
    this.trademarkService.queryTrademarks(this.query).subscribe(data => {
      this.queryResult = data;
      this.global.pageLoading = false;
    }, error => {
      this.global.pageLoading = false;
      this.toastr.error('Error loading trademarks');
    });
  }

  openTrademarkModal(trademarkId) {
    if (trademarkId) {
      this.global.pageLoading = true;
      this.trademarkService.getTrademark(trademarkId)
        .subscribe(data => {
          this.global.pageLoading = false;
          this.trademarkDetail = data;
          this.modalService.open(this.trademarkModal, { windowClass: "lModal" });
        }, error => {
          this.global.pageLoading = false;
          this.toastr.error('Error loading trademark');
        });
    }
    else {
      // For new trademark, auto-set the first granted merchant group
      const firstGroup = this.merchantGroups && this.merchantGroups.length > 0 ? this.merchantGroups[0] : null;
      this.trademarkDetail = {
        id: '',
        text: '',
        note: '',
        merchantGroupId: firstGroup ? firstGroup.id : '',
        merchantGroup: firstGroup || {
          id: '',
          name: ''
        }
      };
      this.modalService.open(this.trademarkModal, { windowClass: "lModal" });
    }
  }

  getMerchantGroups() {
    this.merchantService.getGrantedMerchantGroups().subscribe(data => {
      this.merchantGroups = data;
    });
  }

  saveTrademark() {
    if (!this.trademarkDetail.text) {
      this.toastr.error('Text is required');
      return;
    }
    
    // Ensure merchant group is set (use first granted group if not set)
    if (!this.trademarkDetail.merchantGroupId && this.merchantGroups && this.merchantGroups.length > 0) {
      this.trademarkDetail.merchantGroupId = this.merchantGroups[0].id;
    }
    
    if (!this.trademarkDetail.merchantGroupId) {
      this.toastr.error('No merchant group available');
      return;
    }

    this.global.pageLoading = true;
    this.trademarkService.saveTrademark(this.trademarkDetail).subscribe(data => {
      this.global.pageLoading = false;
      this.modalService.dismissAll();
      this.toastr.success('Trademark saved successfully');
      this.queryTrademarks();
    }, error => {
      this.global.pageLoading = false;
      this.toastr.error('Error saving trademark');
    });
  }

  deleteTrademark(trademark) {
    if (confirm('Are you sure you want to delete this trademark?')) {
      this.global.pageLoading = true;
      this.trademarkService.deleteTrademark(trademark.id).subscribe(data => {
        this.global.pageLoading = false;
        this.toastr.success('Trademark deleted successfully');
        this.queryTrademarks();
      }, error => {
        this.global.pageLoading = false;
        this.toastr.error('Error deleting trademark');
      });
    }
  }

}

